import magnifiAPIInstance from "./apiInstance";

export const featureListAPIs = {
  getFeatureList: ({ featureListId }) => magnifiAPIInstance.get(`/feature/list/${featureListId}`),
};
